jQuery(function () {
  jQuery('.infiniteslide').infiniteslide({
    speed: 40,
    responsive: true,
    direction: 'right',
    'clone': 2
  });
});
